import { createAction } from 'redux-actions';
import {
	FETCH_BEFORE_CHART,
	FETCH_INIT_CHART,
	FETCH_LOOKBACK_CHART,
	SET_BEFORE_CHART,
	SET_INDEX_CHART,
	SET_INIT_CHART,
} from './constants';

export const fetchInitChart = createAction(
	FETCH_INIT_CHART,
	(param: any) => ({ param }),
);

export const fetchBeforeChart = createAction(
	FETCH_BEFORE_CHART,
	(param: any) => ({ param }),
);

export const fetchLookbackChart = createAction(
	FETCH_LOOKBACK_CHART,
	(param: any) => ({ param }),
);

export const setInitChart = createAction(
	SET_INIT_CHART,
	(initChartData: any, id: any, symbol: any) => ({ initChartData, id, symbol }),
);

export const setBeforeChart = createAction(
	SET_BEFORE_CHART,
	(initChartData: any, id: any, symbol: any) => ({ before_chart_data: initChartData, id, symbol }),
);

export const setIndexChart = createAction(
	SET_INDEX_CHART,
	(id: any, symbol: any) => ({ id, symbol }),
);
